module.exports = __webpack_public_path__ + "img/content6.e2e75de5.png";